// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zM22.344 0L13.858 8.485 15.272 9.9l7.9-7.9h-.828zm5.656 0L19.515 8.485 17.343 10.657l7.9-7.9h2.757zm5.656 0L24.172 8.485 26.343 10.657l7.9-7.9h-.828zm5.656 0L29.828 8.485 32 10.657l7.9-7.9h-2.83zm5.657 0L35.485 8.485 37.657 10.657l7.9-7.9h-2.83zm5.657 0L41.142 8.485 43.314 10.657l7.9-7.9h-2.83zm5.657 0L46.8 8.485 48.97 10.657l7.9-7.9h-2.83zm5.657 0L52.456 8.485 54.627 10.657l7.9-7.9h-2.83zM32 0l1.414 1.414 16.97 16.97-1.414 1.415L32 2.828 14.03 20.8l-1.414-1.415L29.586 2.414 31 1 32 0zm0 0L32 0 32 0z%27 fill=%27%23292945%27 fill-opacity=%270.1%27 fill-rule=%27evenodd%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/logobig.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page {
  min-height: 100vh;
  background: #151515;
  color: #ffffff;
}

.main-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: rgba(20, 20, 25, 0.95);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
  z-index: 1000;
}

.header-logo {
  height: 50px;
}

.header-buttons {
  display: flex;
  gap: 1rem;
}

.main-content {
  padding-top: 80px;
}

.hero-section {
  min-height: 80vh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  padding: 1rem 2rem 0;
  background: linear-gradient(135deg, #1a1a2e, #16213e, #1a1a2e);
  align-items: center;
  margin-top: -120px;
  margin-bottom: -4rem;
  position: relative;
  overflow: hidden;
}

/* Add subtle animated gradient overlay to hero section */
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(41, 50, 100, 0.1), rgba(25, 25, 50, 0.1));
  pointer-events: none;
}

.video-container {
  aspect-ratio: 16/9;
  width: 100%;
  display: flex;
  align-items: center;
}

.trailer-video {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  max-height: 70vh;
}

.hero-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
  padding: 2rem 0;
}

.hero-content .cta-button {
  margin: 0 auto;
}

.hero-content h2 {
  font-family: Kim, sans-serif;
  font-size: 3.5rem;
  font-weight: 800;
  color: #ffffff;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  letter-spacing: 1px;
  line-height: 1.1;
  margin: 0;
}

.hero-content h3 {
  font-family: Kim, sans-serif;
  font-size: 1.5rem;
  color: #ffffff;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  letter-spacing: 0.5px;
  margin: 0;
}

.hero-content p {
  font-size: 1.25rem;
  line-height: 1.4;
  opacity: 0.9;
  max-width: 540px;
  margin: 0 auto;
  color: #ffffff;
}

.news-section {
  padding: 4rem 2rem;
  background: linear-gradient(180deg, #1a1a2e 0%, #252538 100%);
  position: relative;
}

/* Add subtle pattern overlay to news section */
.news-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  pointer-events: none;
}

.news-section h2 {
  font-family: Kim, sans-serif;
  font-size: 3rem;
  color: #ffffff;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  text-align: center;
  margin-bottom: 2rem;
  letter-spacing: 0.5px;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;
}

.news-card {
  background: linear-gradient(135deg, #2a2a45, #252538);
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.2s;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.news-card:hover {
  transform: translateY(-5px);
}

.news-media {
  position: relative;
  width: 100%;
  height: 350px;
  overflow: hidden;
}

.news-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.news-content {
  padding: 1.5rem;
}

.news-category {
  background: #ff4d4d;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 1.125rem;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 0.75rem;
}

.news-card h3 {
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
  color: #ffffff;
}

.news-card p {
  font-size: 1.25rem;
  line-height: 1.4;
  opacity: 0.9;
  margin-bottom: 1rem;
}

.features-section {
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #252538, #2a2a45, #252538);
  text-align: center;
  position: relative;
}

/* Add subtle animated glow to features section */
.features-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(75, 75, 150, 0.1), transparent 70%);
  pointer-events: none;
}

.features-section h2 {
  font-family: Kim, sans-serif;
  font-size: 3rem;
  color: #ffffff;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  text-align: center;
  margin-bottom: 2rem;
  letter-spacing: 0.5px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  margin: 3rem 0;
}

.feature-card {
  background: linear-gradient(135deg, rgba(50, 50, 80, 0.2), rgba(40, 40, 70, 0.2));
  padding: 1.75rem;
  border-radius: 12px;
  transition: all 0.3s;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  position: relative;
  overflow: hidden;
}

.feature-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #ffcc00, #ffaa00);
  opacity: 0;
  transition: opacity 0.3s;
}

.feature-card:hover {
  transform: translateY(-5px);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.feature-card:hover::before {
  opacity: 1;
}

.feature-card h3 {
  font-size: 1.75rem;
  margin-bottom: 0.75rem;
  font-family: Kim, sans-serif;
  color: #ffffff;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  letter-spacing: 0.5px;
}

.feature-card p {
  font-size: 1.25rem;
  line-height: 1.4;
  opacity: 0.9;
  color: #ffffff;
}

.classes-section {
  padding: 4rem 2rem;
  background: linear-gradient(180deg, #252538 0%, #1f1f30 100%);
  text-align: center;
  position: relative;
}

/* Remove the ::before pseudo-element that creates the checkers pattern */
.classes-section::before {
  display: none;
}

.classes-section h2 {
  font-family: Kim, sans-serif;
  font-size: 3rem;
  color: #ffffff;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  text-align: center;
  margin-bottom: 2rem;
  letter-spacing: 0.5px;
}

.classes-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin: 3rem 0;
}

.class-card {
  background: linear-gradient(135deg, rgba(50, 50, 80, 0.2), rgba(40, 40, 70, 0.2));
  padding: 2rem;
  border-radius: 12px;
  transition: transform 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
}

.class-card:hover {
  transform: translateY(-5px);
}

.class-image {
  height: 200px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.cta-button {
  display: inline-block;
  min-width: 200px;
  max-width: 300px;
  background-color: #ffcc00;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-family: Kim, sans-serif;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  font-size: 1.5rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  letter-spacing: 0.5px;
  line-height: 1.2;
}

.cta-button:hover {
  transform: translateY(-2px);
  background-color: #ffaa00;
}

.login-button {
  background: transparent;
  border: 2px solid #ffffff;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-family: Kim, sans-serif;
  padding: 0.5rem 1.5rem;
  border-radius: 8px;
  font-size: 1.25rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  letter-spacing: 0.5px;
  line-height: 1.2;
}

.login-button:hover {
  background: #ffffff;
  color: #0a0a0a;
  text-shadow: none;
}

.login-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.login-dialog {
  background: #1a1a1a;
  padding: 2rem;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  position: relative;
}

.login-header {
  margin: 4rem 0 2rem;
}

.login-header p {
  font-family: Kim, sans-serif;
  font-size: 1.5rem;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

/* Add logo at the top */
.login-dialog::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 120px;
  height: 120px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.back-button {
  display: block;
  margin: 2rem auto 0;
  padding: 0.75rem 2rem;
  background: transparent;
  border: 2px solid #ffffff;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  font-family: Kim, sans-serif;
  border-radius: 8px;
  font-size: 1.25rem;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button:hover {
  background: #ffffff;
  color: #0a0a0a;
  text-shadow: none;
}

.legal-footer {
  background: #1a1a2e;
  padding: 2rem;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.legal-link {
  background: none;
  border: none;
  color: #ffffff;
  opacity: 0.7;
  text-decoration: none;
  transition: opacity 0.2s;
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
}

.legal-link:hover {
  opacity: 1;
}

.separator {
  margin: 0 1rem;
  opacity: 0.7;
  color: #ffffff;
}

@media (max-width: 1024px) {
  .hero-section {
    grid-template-columns: 1fr;
    gap: 3rem;
    padding: 2rem 2rem 1rem;
    margin-top: -70px;
    margin-bottom: -2rem;
  }
  
  .video-container {
    max-width: 800px;
    margin: 0 auto;
  }
  
  .hero-content {
    text-align: center;
    margin: 0 auto;
    margin-top: -3rem;
  }
  
  .news-grid,
  .features-grid,
  .classes-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .news-grid,
  .features-grid,
  .classes-grid {
    grid-template-columns: 1fr;
  }
  
  .hero-content h1 {
    font-size: 2.5rem;
  }
  
  .hero-content h2 {
    font-size: 3.5rem;
  }
  
  .hero-content h3 {
    font-size: 2rem;
  }
  
  .cta-button {
    min-width: 180px;
    max-width: 250px;
  }
  
  .news-section h2,
  .features-section h2,
  .classes-section h2 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }
  
  .feature-card p {
    font-size: 1.125rem;
  }
  
  .news-card h3 {
    font-size: 1.25rem;
  }
  
  .news-card p {
    font-size: 1.125rem;
  }
}

time {
  font-size: 1rem;
  opacity: 0.7;
  display: block;
}

.class-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #ffffff;
}

.class-card p {
  font-size: 1.25rem;
  line-height: 1.4;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .class-card h3 {
    font-size: 1.25rem;
  }

  .class-card p {
    font-size: 1.125rem;
  }
}

.legal-content {
  padding: 2rem 3rem;
  color: #000000;
  max-height: 80vh;
  overflow-y: auto;
}

/* Add custom scrollbar styling */
.legal-content::-webkit-scrollbar {
  width: 8px;
}

.legal-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.legal-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.legal-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media (max-width: 768px) {
  .legal-content {
    padding: 1.5rem;
    max-height: 70vh; /* Slightly smaller on mobile */
  }
}

.legal-content h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  color: #000000;
  font-family: Kim, sans-serif;
  text-align: center;
}

.legal-content h3 {
  font-size: 1.75rem;
  margin: 2rem 0 1rem;
  color: #000000;
}

.legal-content p,
.legal-content li {
  font-size: 1.125rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  color: #000000;
}

.legal-content ul {
  margin: 1rem 0 1.5rem 2rem;
}

.legal-content li {
  margin-bottom: 0.5rem;
}

@media (max-width: 1200px) {
  .features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .features-grid {
    grid-template-columns: 1fr;
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.news-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 300px;
  grid-column: 1 / -1;
}

.no-news {
  text-align: center;
  grid-column: 1 / -1;
  padding: 2rem;
  color: #666;
}

.steam-wishlist-button {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background-color: #1a9fff; /* A steam-like blue */
  color: white;
  font-weight: bold;
}

.steam-wishlist-button .steam-icon {
  width: 48px;
  height: 48px;
}

.header-wishlist-btn {
  padding: 10px 20px;
  font-size: 1rem;
  text-transform: uppercase;
}

.header-wishlist-btn .steam-icon {
  width: 20px;
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/routes/LandingPage.style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,8DAA8D;EAC9D,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iFAAiF;EACjF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iEAAiE;EACjE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,iEAAiE;EACjE,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yDAA49B;EAC59B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,iEAAiE;EACjE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8DAA8D;EAC9D,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,uFAAuF;EACvF,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,iEAAiE;EACjE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iFAAiF;EACjF,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,cAAc;EACd,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,cAAc;EACd,iEAAiE;EACjE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iFAAiF;EACjF,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,iEAAiE;EACjE,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,iEAAiE;EACjE,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,iEAAiE;AACnE;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,yDAA4C;EAC5C,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,iEAAiE;EACjE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,iBAAiB;EACnB;;EAEA;;;IAGE,qCAAqC;EACvC;AACF;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;;;IAGE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB,EAAE,+BAA+B;EACnD;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,yBAAyB,EAAE,sBAAsB;EACjD,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".landing-page {\n  min-height: 100vh;\n  background: #151515;\n  color: #ffffff;\n}\n\n.main-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 80px;\n  background: rgba(20, 20, 25, 0.95);\n  backdrop-filter: blur(10px);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 2rem;\n  z-index: 1000;\n}\n\n.header-logo {\n  height: 50px;\n}\n\n.header-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.main-content {\n  padding-top: 80px;\n}\n\n.hero-section {\n  min-height: 80vh;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  padding: 1rem 2rem 0;\n  background: linear-gradient(135deg, #1a1a2e, #16213e, #1a1a2e);\n  align-items: center;\n  margin-top: -120px;\n  margin-bottom: -4rem;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Add subtle animated gradient overlay to hero section */\n.hero-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, rgba(41, 50, 100, 0.1), rgba(25, 25, 50, 0.1));\n  pointer-events: none;\n}\n\n.video-container {\n  aspect-ratio: 16/9;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.trailer-video {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  max-height: 70vh;\n}\n\n.hero-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.5rem;\n  max-width: 600px;\n  margin: 0 auto;\n  text-align: center;\n  padding: 2rem 0;\n}\n\n.hero-content .cta-button {\n  margin: 0 auto;\n}\n\n.hero-content h2 {\n  font-family: Kim, sans-serif;\n  font-size: 3.5rem;\n  font-weight: 800;\n  color: #ffffff;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  letter-spacing: 1px;\n  line-height: 1.1;\n  margin: 0;\n}\n\n.hero-content h3 {\n  font-family: Kim, sans-serif;\n  font-size: 1.5rem;\n  color: #ffffff;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  letter-spacing: 0.5px;\n  margin: 0;\n}\n\n.hero-content p {\n  font-size: 1.25rem;\n  line-height: 1.4;\n  opacity: 0.9;\n  max-width: 540px;\n  margin: 0 auto;\n  color: #ffffff;\n}\n\n.news-section {\n  padding: 4rem 2rem;\n  background: linear-gradient(180deg, #1a1a2e 0%, #252538 100%);\n  position: relative;\n}\n\n/* Add subtle pattern overlay to news section */\n.news-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M54.627 0l.83.828-1.415 1.415L51.8 0h2.827zM5.373 0l-.83.828L5.96 2.243 8.2 0H5.374zM48.97 0l3.657 3.657-1.414 1.414L46.143 0h2.828zM11.03 0L7.372 3.657 8.787 5.07 13.857 0H11.03zm32.284 0L49.8 6.485 48.384 7.9l-7.9-7.9h2.83zM16.686 0L10.2 6.485 11.616 7.9l7.9-7.9h-2.83zM22.344 0L13.858 8.485 15.272 9.9l7.9-7.9h-.828zm5.656 0L19.515 8.485 17.343 10.657l7.9-7.9h2.757zm5.656 0L24.172 8.485 26.343 10.657l7.9-7.9h-.828zm5.656 0L29.828 8.485 32 10.657l7.9-7.9h-2.83zm5.657 0L35.485 8.485 37.657 10.657l7.9-7.9h-2.83zm5.657 0L41.142 8.485 43.314 10.657l7.9-7.9h-2.83zm5.657 0L46.8 8.485 48.97 10.657l7.9-7.9h-2.83zm5.657 0L52.456 8.485 54.627 10.657l7.9-7.9h-2.83zM32 0l1.414 1.414 16.97 16.97-1.414 1.415L32 2.828 14.03 20.8l-1.414-1.415L29.586 2.414 31 1 32 0zm0 0L32 0 32 0z' fill='%23292945' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E\");\n  pointer-events: none;\n}\n\n.news-section h2 {\n  font-family: Kim, sans-serif;\n  font-size: 3rem;\n  color: #ffffff;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  text-align: center;\n  margin-bottom: 2rem;\n  letter-spacing: 0.5px;\n}\n\n.news-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.news-card {\n  background: linear-gradient(135deg, #2a2a45, #252538);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: transform 0.2s;\n  cursor: pointer;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.news-card:hover {\n  transform: translateY(-5px);\n}\n\n.news-media {\n  position: relative;\n  width: 100%;\n  height: 350px;\n  overflow: hidden;\n}\n\n.news-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.news-image {\n  width: 100%;\n  height: 100%;\n  background-size: cover;\n  background-position: center;\n}\n\n.news-content {\n  padding: 1.5rem;\n}\n\n.news-category {\n  background: #ff4d4d;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 1.125rem;\n  font-weight: 500;\n  display: inline-block;\n  margin-bottom: 0.75rem;\n}\n\n.news-card h3 {\n  font-size: 1.5rem;\n  margin-bottom: 0.75rem;\n  color: #ffffff;\n}\n\n.news-card p {\n  font-size: 1.25rem;\n  line-height: 1.4;\n  opacity: 0.9;\n  margin-bottom: 1rem;\n}\n\n.features-section {\n  padding: 4rem 2rem;\n  background: linear-gradient(135deg, #252538, #2a2a45, #252538);\n  text-align: center;\n  position: relative;\n}\n\n/* Add subtle animated glow to features section */\n.features-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 50% 50%, rgba(75, 75, 150, 0.1), transparent 70%);\n  pointer-events: none;\n}\n\n.features-section h2 {\n  font-family: Kim, sans-serif;\n  font-size: 3rem;\n  color: #ffffff;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  text-align: center;\n  margin-bottom: 2rem;\n  letter-spacing: 0.5px;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 2rem;\n  margin: 3rem 0;\n}\n\n.feature-card {\n  background: linear-gradient(135deg, rgba(50, 50, 80, 0.2), rgba(40, 40, 70, 0.2));\n  padding: 1.75rem;\n  border-radius: 12px;\n  transition: all 0.3s;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(5px);\n  position: relative;\n  overflow: hidden;\n}\n\n.feature-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, #ffcc00, #ffaa00);\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.feature-card:hover::before {\n  opacity: 1;\n}\n\n.feature-card h3 {\n  font-size: 1.75rem;\n  margin-bottom: 0.75rem;\n  font-family: Kim, sans-serif;\n  color: #ffffff;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  letter-spacing: 0.5px;\n}\n\n.feature-card p {\n  font-size: 1.25rem;\n  line-height: 1.4;\n  opacity: 0.9;\n  color: #ffffff;\n}\n\n.classes-section {\n  padding: 4rem 2rem;\n  background: linear-gradient(180deg, #252538 0%, #1f1f30 100%);\n  text-align: center;\n  position: relative;\n}\n\n/* Remove the ::before pseudo-element that creates the checkers pattern */\n.classes-section::before {\n  display: none;\n}\n\n.classes-section h2 {\n  font-family: Kim, sans-serif;\n  font-size: 3rem;\n  color: #ffffff;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  text-align: center;\n  margin-bottom: 2rem;\n  letter-spacing: 0.5px;\n}\n\n.classes-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  margin: 3rem 0;\n}\n\n.class-card {\n  background: linear-gradient(135deg, rgba(50, 50, 80, 0.2), rgba(40, 40, 70, 0.2));\n  padding: 2rem;\n  border-radius: 12px;\n  transition: transform 0.2s;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(5px);\n}\n\n.class-card:hover {\n  transform: translateY(-5px);\n}\n\n.class-image {\n  height: 200px;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n}\n\n.cta-button {\n  display: inline-block;\n  min-width: 200px;\n  max-width: 300px;\n  background-color: #ffcc00;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-family: Kim, sans-serif;\n  padding: 0.75rem 2rem;\n  border-radius: 8px;\n  font-size: 1.5rem;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n  letter-spacing: 0.5px;\n  line-height: 1.2;\n}\n\n.cta-button:hover {\n  transform: translateY(-2px);\n  background-color: #ffaa00;\n}\n\n.login-button {\n  background: transparent;\n  border: 2px solid #ffffff;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-family: Kim, sans-serif;\n  padding: 0.5rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1.25rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  letter-spacing: 0.5px;\n  line-height: 1.2;\n}\n\n.login-button:hover {\n  background: #ffffff;\n  color: #0a0a0a;\n  text-shadow: none;\n}\n\n.login-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1001;\n}\n\n.login-dialog {\n  background: #1a1a1a;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n  position: relative;\n}\n\n.login-header {\n  margin: 4rem 0 2rem;\n}\n\n.login-header p {\n  font-family: Kim, sans-serif;\n  font-size: 1.5rem;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n}\n\n/* Add logo at the top */\n.login-dialog::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 120px;\n  height: 120px;\n  background-image: url('@assets/logobig.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.back-button {\n  display: block;\n  margin: 2rem auto 0;\n  padding: 0.75rem 2rem;\n  background: transparent;\n  border: 2px solid #ffffff;\n  color: white;\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\n  font-family: Kim, sans-serif;\n  border-radius: 8px;\n  font-size: 1.25rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button:hover {\n  background: #ffffff;\n  color: #0a0a0a;\n  text-shadow: none;\n}\n\n.legal-footer {\n  background: #1a1a2e;\n  padding: 2rem;\n  text-align: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.legal-link {\n  background: none;\n  border: none;\n  color: #ffffff;\n  opacity: 0.7;\n  text-decoration: none;\n  transition: opacity 0.2s;\n  font-size: 1rem;\n  cursor: pointer;\n  padding: 0;\n}\n\n.legal-link:hover {\n  opacity: 1;\n}\n\n.separator {\n  margin: 0 1rem;\n  opacity: 0.7;\n  color: #ffffff;\n}\n\n@media (max-width: 1024px) {\n  .hero-section {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n    padding: 2rem 2rem 1rem;\n    margin-top: -70px;\n    margin-bottom: -2rem;\n  }\n  \n  .video-container {\n    max-width: 800px;\n    margin: 0 auto;\n  }\n  \n  .hero-content {\n    text-align: center;\n    margin: 0 auto;\n    margin-top: -3rem;\n  }\n  \n  .news-grid,\n  .features-grid,\n  .classes-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .news-grid,\n  .features-grid,\n  .classes-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .hero-content h1 {\n    font-size: 2.5rem;\n  }\n  \n  .hero-content h2 {\n    font-size: 3.5rem;\n  }\n  \n  .hero-content h3 {\n    font-size: 2rem;\n  }\n  \n  .cta-button {\n    min-width: 180px;\n    max-width: 250px;\n  }\n  \n  .news-section h2,\n  .features-section h2,\n  .classes-section h2 {\n    font-size: 2.5rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .feature-card p {\n    font-size: 1.125rem;\n  }\n  \n  .news-card h3 {\n    font-size: 1.25rem;\n  }\n  \n  .news-card p {\n    font-size: 1.125rem;\n  }\n}\n\ntime {\n  font-size: 1rem;\n  opacity: 0.7;\n  display: block;\n}\n\n.class-card h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: #ffffff;\n}\n\n.class-card p {\n  font-size: 1.25rem;\n  line-height: 1.4;\n  opacity: 0.9;\n}\n\n@media (max-width: 768px) {\n  .class-card h3 {\n    font-size: 1.25rem;\n  }\n\n  .class-card p {\n    font-size: 1.125rem;\n  }\n}\n\n.legal-content {\n  padding: 2rem 3rem;\n  color: #000000;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n/* Add custom scrollbar styling */\n.legal-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.legal-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.legal-content::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.legal-content::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n@media (max-width: 768px) {\n  .legal-content {\n    padding: 1.5rem;\n    max-height: 70vh; /* Slightly smaller on mobile */\n  }\n}\n\n.legal-content h2 {\n  font-size: 2.5rem;\n  margin-bottom: 2rem;\n  color: #000000;\n  font-family: Kim, sans-serif;\n  text-align: center;\n}\n\n.legal-content h3 {\n  font-size: 1.75rem;\n  margin: 2rem 0 1rem;\n  color: #000000;\n}\n\n.legal-content p,\n.legal-content li {\n  font-size: 1.125rem;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n  color: #000000;\n}\n\n.legal-content ul {\n  margin: 1rem 0 1.5rem 2rem;\n}\n\n.legal-content li {\n  margin-bottom: 0.5rem;\n}\n\n@media (max-width: 1200px) {\n  .features-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .features-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n.news-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-height: 300px;\n  grid-column: 1 / -1;\n}\n\n.no-news {\n  text-align: center;\n  grid-column: 1 / -1;\n  padding: 2rem;\n  color: #666;\n}\n\n.steam-wishlist-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  background-color: #1a9fff; /* A steam-like blue */\n  color: white;\n  font-weight: bold;\n}\n\n.steam-wishlist-button .steam-icon {\n  width: 48px;\n  height: 48px;\n}\n\n.header-wishlist-btn {\n  padding: 10px 20px;\n  font-size: 1rem;\n  text-transform: uppercase;\n}\n\n.header-wishlist-btn .steam-icon {\n  width: 20px;\n  height: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
